// @flow
import * as React from "react";

type Props = {
	_ref: (el: any) => void;
	element: string;
	children: React.Element<*>;
	render?: boolean;
};

type State = {
	render: boolean;
};

class TransitionElem extends React.Component {
	props: Props;
	state: State;
	transition: "entering" | "normal" | "leaving";

	elem: HTMLElement;
	setElem = (el: HTMLElement) => {
		if(this.elem !== el && el) {
			el.addEventListener("transitionend", this.transitionEnd);
		}
		this.elem = el;
		if (this.props._ref) {
			this.props._ref(el);
		}
	}

	enterEnd = (ev: Event) => {
		const {classList} = this.elem;
		classList.remove("enter");
		classList.remove("enter-active");
		this.transition = "normal";
	}
	leaveEnd = (ev: Event) => {
		const {classList} = this.elem;
		classList.remove("leave-active");
		classList.remove('show');
		this.transition = "normal";
		this.setState({render: false});
	}
	transitionEnd = (ev: Event) => {
		if (ev.target !== this.elem) { return; }
		if (this.transition === 'leaving') {
			this.leaveEnd(ev);
		} else {
			this.enterEnd(ev);
		}
	}

	constructor(props: Props) {
		super(props);
		this.state = {render: props.render === true};
	}

	componentWillReceiveProps(props: Props) {
		const {elem} = this;
		const render = props.render === true;

		if (this.state.render != render) {
			if (render) {
				this.transition = "entering";
				this.setState({render: true});
			} else {
				this.transition = "leaving";
			}
		}
	}

	componentDidUpdate() {
		const {elem, transition} = this;
		if (!elem) { return; }
		const {classList} = elem;
		if (transition === "entering") {
			classList.add("enter");
			classList.add("enter-active");
		} else if (transition === "leaving") {
			classList.add("leave-active");
		}
	}

	render() {
		const {render} = this.state;
		if(!this.props.renderHidden && !render) { return null; }
		const {_ref, element, render: _render, children, ...props} = this.props;
		delete props.renderHidden;
		return React.createElement(element, Object.assign({ref: this.setElem}, props, {style: { display: render ? null : 'none' }}), children);
	}
}

export default TransitionElem;



// WEBPACK FOOTER //
// ./lib/navigation/transition.js